class SizeGuideCalculator {
  constructor(root) {
    this.root = root;
    this.height = root.querySelector('[data-size-guide-height]');
    this.weight = root.querySelector('[data-size-guide-weight]');
    this.bust = root.querySelector('[data-size-guide-bust]');
    this.waist = root.querySelector('[data-size-guide-waist]');
    this.hips = root.querySelector('[data-size-guide-hips]');
    this.result = root.querySelector('[data-size-guide-result]');
    this.error = root.querySelector('[data-size-guide-error]');
    this.dress = root.querySelector('[data-size-guide-dress]');
    this.relaxed = root.querySelector('[data-size-guide-relaxed]');
    root.querySelector('[data-size-guide-submit]').addEventListener('click', () => this.calculate());
    [this.height, this.weight, this.bust, this.waist, this.hips].forEach((input) => input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') this.calculate();
    }));
  }

  calculate() {
    const bust = Number(this.bust.value);
    const waist = Number(this.waist.value);
    const hips = Number(this.hips.value);
    const hasMeasurements = bust >= 28 && bust <= 48 && waist >= 20 && waist <= 40 && hips >= 30 && hips <= 50;
    const inches = Number(this.height.value);
    const pounds = Number(this.weight.value);
    const hasHeightWeight = inches >= 47 && inches <= 87 && pounds >= 77 && pounds <= 353;
    const valid = hasMeasurements || hasHeightWeight;
    this.error.hidden = valid;
    if (!valid) return;

    const sizes = [
      { name: 'S/M', us: 'US 0–6', bust: [30, 36], waist: [23, 28], hips: [33, 39] },
      { name: 'M/L', us: 'US 6–12', bust: [36, 43], waist: [28, 35], hips: [39, 45] }
    ];
    let choice;
    if (hasMeasurements) {
      const distance = (value, range) => value < range[0] ? range[0] - value : value > range[1] ? value - range[1] : 0;
      choice = sizes.reduce((best, size) => {
        const score = distance(bust, size.bust) + (distance(waist, size.waist) * 1.25) + distance(hips, size.hips);
        return !best || score < best.score ? { size, score } : best;
      }, null).size;
      this.dress.textContent = `Resortwear: ${choice.name} · ${choice.us}`;
      this.relaxed.textContent = `Sets & layering: ${choice.name}`;
    } else {
      const bmi = (pounds * 703) / Math.pow(inches, 2);
      choice = bmi <= 23.2 ? sizes[0] : sizes[1];
      this.dress.textContent = `Starting point: ${choice.name} · ${choice.us}`;
      this.relaxed.textContent = 'Add your bust, waist and hips for a more precise fit.';
    }
    this.result.hidden = false;
  }
}

document.querySelectorAll('[data-size-guide-calculator]').forEach((root) => new SizeGuideCalculator(root));

class SizeGuideTabs {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-size-guide-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-size-guide-panel]'));
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.show(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.tabs[nextIndex].focus();
        this.show(this.tabs[nextIndex]);
      });
    });
  }

  show(activeTab) {
    const activePanel = activeTab.dataset.sizeGuideTab;
    this.tabs.forEach((tab) => {
      const active = tab === activeTab;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activePanel;
    });
  }
}

document.querySelectorAll('[data-size-guide-tabs]').forEach((root) => new SizeGuideTabs(root));
